// infinityButton.js
var InfinityButton = pc.createScript('infinityButton');

// initialize code called once per entity
InfinityButton.prototype.initialize = function() {
    this.anim = this.entity.children[1];
    this.entity.element.on('click', this.up, this);
    this.entity.element.on('mouseenter', this.onEnter, this);
    this.entity.element.on('mouseleave', this.onLeave, this);
    this.app.on('cameraController:haltRotation', this.out, this);
    this.app.on('solarSystem:allPlanets', this.setActive, this);
    this.app.on('systemGenerator:reset', this.setInActive, this);
    this.switcher = -1;
    this.loading = false;
};

InfinityButton.prototype.setInActive = function(){
    this.loading = false;
};

InfinityButton.prototype.setActive = function(){
    this.loading = true;
};

InfinityButton.prototype.up = function(){
   // console.log('BUTTONUP');
    this.switcher *= -1;
    if(this.switcher == 1){
       // console.log('switcher 1');
        this.entity.element.opacity = 0.5;
        this.anim.enabled = true;
        this.app.fire('cameraController:autoOrbitSystems',  'infinity');
    } else if(this.switcher == -1){
        //console.log('switcher 1');
        this.entity.element.opacity = 1;
        this.anim.enabled = false;
        this.app.fire('cameraController:haltRotation');
    }
};

InfinityButton.prototype.out = function(){
    this.entity.element.opacity = 0.5;
    this.anim.enabled = false;
};

InfinityButton.prototype.onEnter = function(){
    if(this.loading){
        this.entity.children[0].enabled = true;
    }
};

InfinityButton.prototype.onLeave = function(){
    if(this.loading){
        this.entity.children[0].enabled = false;
    }
};


// update code called every frame
InfinityButton.prototype.update = function(dt) {
    
};

// swap method called for script hot-reloading
// inherit your script state here
// InfinityButton.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

